import React from 'react';
import { App } from '@gin-betting/core';

import type { ListNavTab } from 'types';
import { Loader } from 'components';
import ui from 'modules/ui';
import './topMenu.scss';

interface Props {
    homeTabs: ListNavTab[];
    fetchStatus: App.FetchStatus;
}

const {
    components: { ListNav },
} = ui;

const TopMenu: React.FC<Props> = ({ homeTabs, fetchStatus, children }) => {
    return (
        <div styleName="container" className="__app-TopMenu-container">
            <div styleName="header">
                <ListNav tabs={homeTabs} />
                {children}
            </div>
            <div styleName="loader-block">
                <Loader initialProgressValue={0} fetchStatus={fetchStatus} />
            </div>
        </div>
    );
};

export default React.memo(TopMenu);
